module.exports = __webpack_public_path__ + "img/QRJd.e8fac8f8.png";